import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cardFormat'})
export class CardFormat implements PipeTransform {
  transform(value: string): string {
    let formattedValue = "";

    if (value.length === 16) {
      //Card Number Controller
      value.split('').forEach((_value, _index) => {
        formattedValue += _value;
        if ((_index + 1) % 4 === 0) {
          formattedValue += ' ';
        }
      });
      return formattedValue;
    } else {
      return value;
    }
  }
}
